import { scrolledHeader, clickedHamburger } from './modules/header';
scrolledHeader();
clickedHamburger();

import runSwiper from './modules/swiper';
runSwiper();

// object-fit。
import objectFitImages from 'object-fit-images';
objectFitImages();

// Font Awesome。
import { config, dom, library } from '@fortawesome/fontawesome-svg-core';
import {
	faCog,
} from '@fortawesome/free-solid-svg-icons';

import {
	faTrashAlt,
	faEnvelope,
} from '@fortawesome/free-regular-svg-icons';

library.add(
	faCog,
	faTrashAlt,
	faEnvelope,
);
dom.i2svg();

// ポップアップ
function popupImage() {
	let popup = document.getElementById('js-popup');
	if(!popup) return;

	let blackBg = document.getElementById('js-black-bg');
	let showBtn = document.getElementById('js-popup-triger');

	closePopUp(blackBg);
	closePopUp(showBtn);
	function closePopUp(elem) {
		if(!elem) return;
		elem.addEventListener('click', function() {
		popup.classList.toggle('is-show');
		});
	}
}
popupImage();

var Ease = {
	easeInOut: function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1; }
  }
  var duration = 500;
  window.addEventListener('DOMContentLoaded', function () {
	var smoothScrollTriggers = [].slice.call(document.querySelectorAll('a[href^="#"]'));
	smoothScrollTriggers.forEach(function (smoothScrollTrigger) {
	  smoothScrollTrigger.addEventListener('click', function (e) {
		var href = smoothScrollTrigger.getAttribute('href');
		var currentPostion = document.documentElement.scrollTop || document.body.scrollTop;
		var targetElement = document.getElementById(href.replace('#', ''));
		if (targetElement) {
		  e.preventDefault();
		  e.stopPropagation();
		  var targetPosition = window.pageYOffset + targetElement.getBoundingClientRect().top - 80;
		  var startTime = performance.now();
		  var loop = function (nowTime) {
			var time = nowTime - startTime;
			var normalizedTime = time / duration;
			if (normalizedTime < 1) {
			  window.scrollTo(0, currentPostion + ((targetPosition - currentPostion) * Ease.easeInOut(normalizedTime)));
			  requestAnimationFrame(loop);
			} else {
			  window.scrollTo(0, targetPosition);
			}
		  }
		  requestAnimationFrame(loop);
		}
	  });
	});
  });

  document.addEventListener('DOMContentLoaded', function() {
    const fadeIns = document.querySelectorAll('.c-fadein');
    const cb = function(entries, observer) {
        entries.forEach(entry => {
            if(entry.isIntersecting) {
                entry.target.classList.add('is-active');
                observer.unobserve(entry.target); //1回で処理を停止
            } else {
                entry.target.classList.remove('is-active');
            }
        });
    }
    const io = new IntersectionObserver(cb);
    fadeIns.forEach(fadeIn => io.observe(fadeIn));
});